const tenants = {
    title: 'الإعدادات',
    description: 'إدارة إعدادات المستأجر بكفاءة وتخصيص نطاقك.',
    oss_description: 'قم بتغيير إعدادات حسابك وإدارة معلوماتك الشخصية هنا لضمان أمان حسابك.',
    tabs: {
        settings: 'الإعدادات',
        members: 'الأعضاء',
        domains: 'النطاقات',
        oidc_configs: 'إعدادات OIDC',
        subscription: 'الخطة والفوترة',
        billing_history: 'سجل الفوترة',
        license: 'الترخيص',
    },
    license: {
        purchase_title: 'خطط الاستضافة الذاتية',
        purchase_description: 'تفتح خطتا Pro والمؤسسة للاستضافة الذاتية ميزات مدفوعة على مثيلك الخاص، مثل إخفاء علامة Logto التجارية، واستخدام واجهتك الخاصة، والتعاون في وحدة التحكم، وتطبيقات SAML غير محدودة. اشترِ خطة للحصول على مفتاح الترخيص.',
        purchase_button: 'عرض خطط الاستضافة الذاتية',
        install_title: 'تثبيت الترخيص',
        install_description: 'الصق مفتاح الترخيص الذي حصلت عليه بعد شراء خطة استضافة ذاتية.',
        install_button: 'تثبيت الترخيص',
        key_field: 'مفتاح الترخيص',
        key_field_description: 'يتم التحقق من المفتاح على مثيلك ولا يغادره أبدًا. تواصل مع Logto للحصول على مفتاح جديد إذا كان المفتاح الحالي منتهي الصلاحية.',
        key_placeholder: 'الصق مفتاح الترخيص هنا',
        installed_toast: 'تم تثبيت الترخيص بنجاح.',
        details_title: 'الترخيص',
        details_description: 'الترخيص المثبت على هذا المثيل وما يمنحه.',
        plan_field: 'الخطة',
        environment_field: 'البيئة',
        environment_production: 'الإنتاج',
        environment_non_production: 'غير الإنتاج',
        expires_at_field: 'ينتهي في',
        installed_at_field: 'تم التثبيت في',
        last_refreshed_at_field: 'آخر تحديث في',
        grace_ends_at_field: 'تنتهي فترة السماح في',
        refresh_expired_description: 'انتهت صلاحية مفتاح الترخيص في {{expiresAt}}. ستبقى الميزات المرخصة متاحة حتى {{graceEndsAt}} بينما يحاول Logto تحديثه.',
        refresh_refused_description: 'تم رفض تحديث الترخيص لأن حالة الترخيص هي {{reason}}. ستبقى الميزات المرخصة متاحة حتى {{graceEndsAt}}.',
        refusal_reason_canceled: 'ملغى',
        refusal_reason_unpaid: 'غير مدفوع',
        refusal_reason_expired: 'منتهي الصلاحية',
        refusal_reason_revoked: 'مسحوب',
        refusal_reason_unknown: 'غير متاح',
        grace_expired_description: 'انتهت فترة السماح للترخيص في {{graceEndsAt}}. عاد هذا النشر إلى إعدادات OSS الافتراضية. تواصل مع Logto للحصول على مفتاح ترخيص جديد وثبّته مرة أخرى.',
        get_fresh_key_button: 'الحصول على مفتاح ترخيص جديد',
        replace_button: 'استبدال الترخيص',
    },
    members: {
        card_title: 'أدر المستأجرين بأمان أكبر مع Logto Cloud',
        card_description: 'أضف مسؤولين أو متعاونين إلى المستأجر الخاص بك دون مشاركة حساب مسؤول واحد.',
        card_action: 'استكشف Logto Cloud',
        self_hosted_card_title: 'أدر المستأجرين بأمان أكبر مع خطط الاستضافة الذاتية',
        self_hosted_card_description: 'أضف مسؤولين أو متعاونين إلى المستأجر الخاص بك دون مشاركة حساب مسؤول واحد.',
        self_hosted_card_action: 'استكشف خطط الاستضافة الذاتية',
    },
    settings: {
        title: 'الإعدادات',
        description: 'تعيين اسم المستأجر وعرض منطقة البيانات المستضيفة ونوع المستأجر.',
        tenant_id: 'معرف المستأجر',
        tenant_name: 'اسم المستأجر',
        tenant_instance: 'اختر مثيلك',
        tenant_instance_description: 'اختر المكان الذي سيتم استضافة المستأجر الخاص بك فيه. اختر Logto Cloud للبنية التحتية العامة المشتركة ، أو مثيل خاص للحصول على موارد مخصصة.',
        tenant_region: 'منطقة البيانات',
        tenant_region_description: 'الموقع الفعلي الذي يتم استضافة موارد المستأجر الخاصة بك (المستخدمين ، التطبيقات ، إلخ). لا يمكن تغييره بعد الإنشاء.',
        tenant_region_tip: 'موارد المستأجر الخاصة بك مستضافة في {{region}}. <a>تعرف على المزيد</a>',
        environment_tag_development: 'تطوير',
        environment_tag_production: 'إنتاج',
        tenant_type: 'نوع المستأجر',
        development_description: 'للاختبار فقط ويجب ألا يستخدم في الإنتاج. لا يلزم اشتراك. لديه جميع الميزات المهنية ولكن لديه قيود مثل لافتة تسجيل الدخول.',
        production_description: 'مخصص للتطبيقات التي يستخدمها المستخدمون النهائيون وقد تتطلب اشتراكًا مدفوعًا.',
        tenant_info_saved: 'تم حفظ معلومات المستأجر بنجاح.',
        tenant_mfa: 'المصادقة متعددة العوامل',
        tenant_mfa_description: 'اطلب من أعضائك إعداد المصادقة متعددة العوامل للوصول إلى هذا المستأجر.',
        oss_description: 'إدارة كيفية وصول الأعضاء إلى وحدة التحكم على هذه النسخة.',
        tenant_mfa_confirm_title: 'طلب المصادقة متعددة العوامل لجميع الأعضاء؟',
        tenant_mfa_confirm_description: 'لم يقم هؤلاء الأعضاء بإعداد المصادقة متعددة العوامل بعد. سيظلون مسجلين الدخول، وسيُطلب منهم إعدادها عند تسجيل الدخول التالي:',
        tenant_mfa_confirm_self: 'لم تقم أنت أيضًا بإعداد المصادقة متعددة العوامل. قم بإعدادها في إعدادات حسابك قبل تسجيل الدخول التالي.',
        tenant_mfa_confirm_button: 'طلب المصادقة متعددة العوامل',
        tenant_mfa_setup_required: 'يتطلب هذا المستأجر المصادقة متعددة العوامل. قم بإعدادها الآن، وإلا سيُطلب منك ذلك عند تسجيل الدخول التالي.',
        tenant_mfa_setup_action: 'إعداد المصادقة متعددة العوامل',
        enterprise_sso: 'Enterprise SSO',
        enterprise_sso_description: 'متاح في الخطط المدفوعة. اتصل بنا لتمكين Enterprise SSO حتى يتمكن جميع الأعضاء من تسجيل الدخول إلى Logto Cloud Console باستخدام موفر هوية مؤسستك.',
    },
    full_env_tag: {
        development: 'تطوير',
        production: 'إنتاج',
    },
    deletion_card: {
        title: 'حذف',
        tenant_deletion: 'حذف المستأجر',
        tenant_deletion_description: 'سيؤدي حذف المستأجر إلى إزالة جميع البيانات والتكوين المرتبطة بشكل دائم. يرجى الاستمرار بحذر.',
        tenant_deletion_button: 'حذف المستأجر',
    },
    leave_tenant_card: {
        title: 'مغادرة',
        leave_tenant: 'مغادرة المستأجر',
        leave_tenant_description: 'سيظل أي موارد في المستأجر ولكن لن يكون لديك الوصول إلى هذا المستأجر بعد الآن.',
        last_admin_note: 'لمغادرة هذا المستأجر ، تأكد من وجود عضو آخر لديه دور المشرف.',
    },
    create_modal: {
        title: 'إنشاء مستأجر',
        subtitle: 'إنشاء مستأجر جديد يحتوي على موارد ومستخدمين معزولين.',
        tenant_id: 'معرف المستأجر',
        tenant_usage_purpose: 'ماذا تريد استخدام هذا المستأجر ل؟',
        development_description: 'للاختبار فقط ويجب ألا يستخدم في الإنتاج. لا يلزم اشتراك.',
        development_description_for_private_regions: 'للاختبار فقط ويجب ألا يستخدم في الإنتاج.',
        development_hint: 'لديه جميع الميزات المهنية ولكن لديه قيود مثل لافتة تسجيل الدخول.',
        production_description: 'للاستخدام من قبل المستخدمين النهائيين وقد يتطلب اشتراكًا مدفوعًا.',
        available_plan: 'الخطة المتاحة:',
        create_button: 'إنشاء مستأجر',
        tenant_name_placeholder: 'مستأجري',
        tenant_created: 'تم إنشاء المستأجر بنجاح.',
        invitation_failed: 'فشل إرسال بعض الدعوات. يرجى المحاولة مرة أخرى في الإعدادات -> الأعضاء لاحقًا.',
        tenant_type_description: 'لا يمكن تغييره بعد الإنشاء.',
        tenant_id_invalid: 'يمكن أن يحتوي معرف المستأجر فقط على أحرف صغيرة وأرقام وواصلات، ويجب ألا يتجاوز {{max}} حرفًا.',
        tenant_id_placeholder: 'معرف المستأجر الخاص بك',
        tenant_id_tip: 'قم بتخصيص معرف المستأجر. إذا ترك فارغًا، سيقوم Logto بإنشاء معرف افتراضي. لا يمكن تغيير معرف المستأجر بعد الإنشاء.',
    },
    dev_tenant_migration: {
        title: 'يمكنك الآن تجربة ميزاتنا المهنية مجانًا عن طريق إنشاء "مستأجر تطوير جديد"!',
        affect_title: 'كيف يؤثر هذا عليك؟',
        hint_1: 'نحن نستبدل <strong>علامات البيئة</strong> القديمة بنوعين جديدين من المستأجر: <strong>"تطوير"</strong> و <strong>"إنتاج"</strong>.',
        hint_2: 'لضمان انتقال سلس ووظائف غير منقطعة ، سيتم رفع جميع المستأجرين الذين تم إنشاؤهم في وقت مبكر إلى نوع المستأجر <strong>الإنتاج</strong> مع اشتراكك السابق.',
        hint_3: 'لا تقلق ، ستظل جميع الإعدادات الأخرى كما هي.',
        about_tenant_type: 'حول نوع المستأجر',
    },
    delete_modal: {
        title: 'حذف المستأجر',
        description_line1: 'هل أنت متأكد أنك تريد حذف المستأجر "<span>{{name}}</span>" مع علامة اللاحقة البيئية "<span>{{tag}}</span>"؟ لا يمكن التراجع عن هذا الإجراء ، وسيؤدي إلى حذف جميع بياناتك ومعلومات المستأجر بشكل دائم.',
        description_line2: 'قبل حذف المستأجر ، ربما يمكننا مساعدتك. <span><a>اتصل بنا عبر البريد الإلكتروني</a></span>',
        description_line3: 'إذا كنت ترغب في المتابعة ، يرجى إدخال اسم المستأجر "<span>{{name}}</span>" للتأكيد.',
        delete_button: 'حذف بشكل دائم',
        cannot_delete_title: 'لا يمكن حذف هذا المستأجر',
        cannot_delete_description: 'عذرًا ، لا يمكنك حذف هذا المستأجر الآن. يرجى التأكد من أنك على خطة مجانية وقد دفعت جميع الفواتير المستحقة.',
    },
    leave_tenant_modal: {
        description: 'هل أنت متأكد أنك تريد مغادرة هذا المستأجر؟',
        leave_button: 'مغادرة',
    },
    tenant_landing_page: {
        title: 'لم تقم بإنشاء مستأجر بعد',
        description: 'لبدء تكوين مشروعك باستخدام Logto ، يرجى إنشاء مستأجر جديد. إذا كنت بحاجة إلى تسجيل الخروج أو حذف حسابك ، فقط انقر فوق زر الصورة الرمزية في الزاوية اليمنى العلوية.',
        create_tenant_button: 'إنشاء مستأجر',
    },
    status: {
        mau_exceeded: 'تجاوز MAU',
        token_exceeded: 'تجاوز الرمز',
        suspended: 'معلق',
        overdue: 'متأخر عن الدفع',
    },
    tenant_suspended_page: {
        title: 'تم تعليق المستأجر. اتصل بنا لاستعادة الوصول.',
        description_1: 'نأسف بشدة لإبلاغك بأن حساب المستأجر الخاص بك تم تعليقه مؤقتًا بسبب الاستخدام غير السليم ، بما في ذلك تجاوز حدود MAU ، وتأخر الدفع ، أو إجراءات غير مصرح بها أخرى.',
        description_2: 'إذا كنت تحتاج إلى توضيحات إضافية أو لديك أي مخاوف أو ترغب في استعادة الوظائف الكاملة وإلغاء حظر المستأجرين الخاص بك ، فيرجى عدم التردد في الاتصال بنا فورًا.',
    },
    production_tenant_notification: {
        text: 'أنت في مستأجر تطوير للاختبار المجاني. قم بإنشاء مستأجر إنتاج للبدء.',
        action: 'إنشاء مستأجر',
    },
};
export default Object.freeze(tenants);
